/**
 * @generated SignedSource<<ef54359ed206c119e561f32773a1d9d6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeleteFlowCommentInput = {
  clientMutationId?: string | null | undefined;
  commentId: UUID;
  flowId: UUID;
};
export type CommentOptionsMutation$variables = {
  input: DeleteFlowCommentInput;
};
export type CommentOptionsMutation$data = {
  readonly deleteFlowComment: {
    readonly comment: {
      readonly rowId: UUID;
    } | null | undefined;
  } | null | undefined;
};
export type CommentOptionsMutation = {
  response: CommentOptionsMutation$data;
  variables: CommentOptionsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CommentOptionsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteFlowCommentPayload",
        "kind": "LinkedField",
        "name": "deleteFlowComment",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Comment",
            "kind": "LinkedField",
            "name": "comment",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CommentOptionsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteFlowCommentPayload",
        "kind": "LinkedField",
        "name": "deleteFlowComment",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Comment",
            "kind": "LinkedField",
            "name": "comment",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "95dcbbf92225b07d74aacce83e91c368",
    "id": null,
    "metadata": {},
    "name": "CommentOptionsMutation",
    "operationKind": "mutation",
    "text": "mutation CommentOptionsMutation(\n  $input: DeleteFlowCommentInput!\n) {\n  deleteFlowComment(input: $input) {\n    comment {\n      rowId\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "fb4163b3e9b0ced5b6b0120e2fc3770d";

export default node;
